export const PRODUCTS_MENU = [
	{
		route: '/global-configuration/product/product-list',
		label: 'Products',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/product/product-list',
				label: 'Product list'
			}
		]
	}
];

export const MAPPERS_MENU = [
	{
		route: '/global-configuration/generic-integrations',
		label: 'Generic Integrations',
		customIconClass: 'fas fa-cog'
	},
	{
		route: '/global-configuration/nexsys-mapper-types/property-types',
		label: 'Nexsys Mapper Types',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/nexsys-mapper-types/property-types',
				label: 'Property Types'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/loan-types',
				label: 'Loan Types'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/loan-reasons',
				label: 'Loan Reasons'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/occupancy-types',
				label: 'Occupancy Types'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/on-hold-reasons',
				label: 'OnHold Reasons'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/document-types',
				label: 'Document Types'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/lender-company-message',
				label: 'LenderCompany Msg'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/milestone-message',
				label: 'Milestone Messages'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/assets-on-completion',
				label: 'Assets On Completion'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/data-message-type',
				label: 'Data Message Type'
			},
			{
				route: '/global-configuration/nexsys-mapper-types/default-settings',
				label: 'Default Settings'
			}
		]
	},
	{
		route: '/global-configuration/valutrust-mapper-types/property-types',
		label: 'ValuTrust Mapper Types',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/valutrust-mapper-types/property-types',
				label: 'Property Types'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/loan-types',
				label: 'Loan Types'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/loan-reasons',
				label: 'Loan Reasons'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/occupancy-types',
				label: 'Occupancy Types'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/document-types',
				label: 'Document Types'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/milestone-message',
				label: 'Milestone Messages'
			},
			{
				route: '/global-configuration/valutrust-mapper-types/default-settings',
				label: 'Default Settings'
			}
		]
	},
	{
		route: '/global-configuration/xpanse-mapper-types/property-types',
		label: 'Xpanse Mapper Types',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/xpanse-mapper-types/property-types',
				label: 'Property Types'
			},
			{
				route: '/global-configuration/xpanse-mapper-types/loan-types',
				label: 'Loan Types'
			},
			{
				route: '/global-configuration/xpanse-mapper-types/loan-reasons',
				label: 'Loan Reasons'
			},
			{
				route: '/global-configuration/xpanse-mapper-types/occupancy-types',
				label: 'Occupancy Types'
			},
			{
				route: '/global-configuration/xpanse-mapper-types/document-types',
				label: 'Document Types'
			},
			{
				route: '/global-configuration/xpanse-mapper-types/default-settings',
				label: 'Default Settings'
			}
		]
	},
	/*
	{
		route: '/global-configuration/fnc-mapper-types/property-types',
		label: 'FNC Mapper Types',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/fnc-mapper-types/property-types',
				label: 'Property Types'
			},
			{
				route: '/global-configuration/fnc-mapper-types/loan-types',
				label: 'Loan Types'
			},
			{
				route: '/global-configuration/fnc-mapper-types/loan-reasons',
				label: 'Loan Reasons'
			},
			{
				route: '/global-configuration/fnc-mapper-types/occupancy-types',
				label: 'Occupancy Types'
			},
			{
				route: '/global-configuration/fnc-mapper-types/on-hold-reasons',
				label: 'OnHold Reasons'
			},
			{
				route: '/global-configuration/fnc-mapper-types/document-types',
				label: 'Document Types'
			},
			{
				route: '/global-configuration/fnc-mapper-types/default-settings',
				label: 'Default Settings'
			}
		]
	}*/
];

export const MONITOR_MENU = [
	{
		route: '/global-configuration/nexsys-monitor/logs',
		label: 'Orders Monitor',
		customIconClass: 'fas fa-cog',
		items:[{}]
	},
];
export const NEXSYS_MONITOR_MENU = {
	route: '/global-configuration/nexsys-monitor/logs',
	label: 'Nexsys Callback logs'
};

export const VALUTRUST_MONITOR_MENU = {
	route: '/global-configuration/valutrust-monitor/logs',
	label: 'ValuTrust Callback logs'
};

export const XPANSE_MONITOR_MENU = {
	route: '/global-configuration/xpanse-monitor/logs',
	label: 'Xpanse Callback logs'
};

export const FNC_MONITOR_MENU = {
	route: '/global-configuration/fnc-monitor/logs',
	label: 'FNC Callback logs'
};

export const ORDERS_MONITOR_MENU = {
	route: '/global-configuration/orders-monitor/orders',
	label: 'Orders'
};

export const NEXSYS_ORPHAND_MONITOR_MENU = {
	route: '/global-configuration/nexsys-legacy-monitor/logs',
	label: 'Nexsys Legacy orders'
};

export const ORDERS_EXTERNAL_MONITOR_MENU = {
	route: '/global-configuration/order-external-monitor/logs',
	label: 'Order External Callback logs'
};

export const EVO_MONITOR_MENU = {
	route: '/global-configuration/evo-monitor/logs',
	label: 'EVO Callback logs'
};

export const MI_MUTUAL_MENU = {
	route: '/global-configuration/mi-mutual/orders',
	label: 'MiMutual Orders'
};

export const RELIANCE_MENU = {
	route: '/global-configuration/reliance-first/orders',
	label: 'Reliance First Orders'
};

export const VALUELINK_MENU = {
	route: '/global-configuration/valuelink-monitor/logs',
	label: 'ValueLink Callback logs'
};
export const VALUELINK_LENDER_MENU = {
	route: '/global-configuration/valuelink-lender-monitor/logs',
	label: 'ValueLink Lender Callback logs'
};

export const CONNEXIONS_MENU = {
	route: '/global-configuration/connexions-monitor/logs',
	label: 'Connexions Callback logs'
};

export const LENDING_QB_MENU = {
	route: '/global-configuration/lending-qb-monitor/logs',
	label: 'LendingQb Callback logs'
};

export const LANDGORILLA_MENU = {
	route: '/global-configuration/landgorilla-monitor/logs',
	label: 'Land Gorilla Callback logs'
};

export const FICS_MENU = {
	route: '/global-configuration/fics-monitor/logs',
	label: 'Fics Callback logs'
};
export const LENDINGPAD_MENU = {
	route: '/global-configuration/lendingpad-monitor/logs',
	label: 'LendingPad Callback logs'
};

export const APPSCOPE_CONFIG_MENU = [
	{
		route: '/global-configuration/app-scope/property-types',
		label: 'AppScope/Acuity Types',
		customIconClass: 'fas fa-cog',
		items: [
			{
				route: '/global-configuration/app-scope/property-types',
				label: 'Property Types'
			},
			{
				route: '/global-configuration/app-scope/loan-types',
				label: 'Loan Types'
			},
			{
				route: '/global-configuration/app-scope/loan-reasons',
				label: 'Loan Reasons'
			},
			{
				route: '/global-configuration/app-scope/occupancy-types',
				label: 'Occupancy Types'
			},
			{
				route: '/global-configuration/app-scope/document-types',
				label: 'Document Types'
			},
		]
	},
	{
		route: '/global-configuration/lender',
		label: 'Lender',
		customIconClass: 'fas fa-cog'
	},
	{
		route: '/global-configuration/software-collector-packages',
		label: 'Software Collector Packages',
		customIconClass: 'fas fa-cog'
	},
	{
		route: '/global-configuration/ci-products',
		label: 'CI Products',
		customIconClass: 'fas fa-cog'
	}
];

export const DELIVERY_ASSETS_CONFIG_MENU = [
	{
		route: '/global-configuration/delivery-assets',
		label: 'Delivery Assets',
		customIconClass: 'fas fa-cog'
	}
];

export const EMAIL_LIST_BY_INTEGRATION_CONFIG_MENU = [
	{
		route: '/global-configuration/email-list',
		label: 'Email List By Integration',
		customIconClass: 'fas fa-cog'
	}
];

export const OUTGOING_EVENTS_HYBRID_ROUTES = [
	{
		route: '/global-configuration/outgoing-events',
		label: 'Outgoing Events',
		customIconClass: 'fas fa-cog'
	}
];

export const CLIENT_IDENTIFIER_CONFIG_MENU = [
	{
		route: '/global-configuration/integrations-list',
		label: 'Client Identifier',
		customIconClass: 'fas fa-cog'
	}
];

export const PRODUCT_IDENTIFIER_CONFIG_MENU = [
	{
		route: '/global-configuration/product-identifier',
		label: 'Product Identifier',
		customIconClass: 'fas fa-cog'
	}
];

export const TENANT_CONFIG_MENU = [
	{
		route: '/global-configuration/tenant-association',
		label: 'Tenants',
		customIconClass: 'fas fa-cog'
	}
];
